export const useBalanceScript = () => {
  return {};
};

export type BalanceState = ReturnType<typeof useBalanceScript>;
